
import { Cup } from "./Cup";
import { DiceHand } from "./DiceHand";
import { UI } from "./UI";
import { store } from "../stores/mainStore";

export function create() {
	const m = window.manager;
	m.scene = this;

	manager.createScene = function(index){
		store.phaserLoading = false;
		if(store.isImmediateRematch){
			store.setSpinner(false);
		}

		console.log('Create Scene Instance', index);
		// store.debug = 'Create Scene Instance '+index;
		if (window.startTime) {
			console.log('load time', Math.round((Date.now() - window.startTime) / 100) / 10);
		}

		let pushDownAmount = m.adjustY(45);

		var borderY = 70*2;
		borderY += pushDownAmount;
		let bounds = this.matter.world.setBounds(20, borderY, m.config.width - 40, m.config.height - borderY).disableGravity();
		Object.values(bounds.walls).forEach(o => o.label = 'bounds');

		// if(m.landscape)

		// // var path = '0 307 0 67 8 55 12 53 57 128 86 94 128 136 148 103 190 159 210 135 222 149 248 109 267 133 293 93 321 128 361 75 381 97 439 4 523 117 551 78 563 92 569 93 603 38 637 99 654 53 701 154 729 109 750 140 800 66 800 307';
		// var path = '0 120 212 60 426 30 638 60 851 120';
		// //  The direct Matter way:
		// // var verts = Phaser.Physics.Matter.Matter.Vertices.fromPath(path);
		// // var body = Phaser.Physics.Matter.Matter.Bodies.fromVertices(408, 492, verts, { ignoreGravity: true }, true, 0.01, 10);
		// // Phaser.Physics.Matter.Matter.World.add(this.matter.world.localWorld, body);
		// //  Or the short-cut version using factory helpers:
		// var verts = this.matter.verts.fromPath(path);
		// var bumper = this.matter.add.fromVertices(456, -20, verts, { ignoreGravity: true });//, true, 0.01, 10);
		// bumper.label = 'bounds';

			let bumper1 = this.matter.add.image(m.adjustX(160) / 2, m.adjustY(25) + pushDownAmount, 'border');
			bumper1.setStatic(true);
			bumper1.setScale(1, m.yAspectDiff);
			bumper1.setAngle(-34);
			bumper1.setFriction(0.005);
			bumper1.body.label = 'bounds';
			let bumper2 = this.matter.add.image(m.config.width - m.adjustX(160) / 2, m.adjustY(25) + pushDownAmount, 'border');
			bumper2.setStatic(true);
			bumper1.setScale(1, m.yAspectDiff);
			bumper2.setAngle(34);
			bumper2.setFriction(0.005);
			bumper2.body.label = 'bounds';

			// bumper1.setDepth(4);
			// bumper2.setDepth(4);


		this.matter.world.on("collisionstart", event => {
			event.pairs.forEach(pair => {
				const {
					bodyA,
					bodyB
				} = pair;
				// const gameObjectA = bodyA.gameObject;
				// const gameObjectB = bodyB.gameObject;

				var aIsDice = false,
					bIsDice = false;
				// const aIsEmoji = gameObjectA instanceof Phaser.Physics.Matter.Sprite;
				// const bIsEmoji = gameObjectB instanceof Phaser.Physics.Matter.Sprite;
				// if(typeof bodyA.tag !== 'undefined')
				// if(bodyA.label == 'Rectangle Body')
				// 	aIsDice = true;
				// if(typeof bodyB.tag !== 'undefined')
				// if(bodyB.label == 'Rectangle Body')
				// 	bIsDice = true;

				// if(aIsDice == true && bIsDice == true)
				// 	return;
				if (bodyA.label === 'bounds')
					bIsDice = true;
				if (bodyB.label === 'bounds')
					aIsDice = true;

				if (aIsDice) {
					// gameObjectA.setAlpha(0.5);
					m.ui.collisionStars(bodyA.position.x, bodyA.position.y);
					//          gameObjectA.play("angry", false);
				}
				if (bIsDice) {
					// gameObjectB.setAlpha(0.5);
					m.ui.collisionStars(bodyB.position.x, bodyB.position.y);
					//          gameObjectB.play("angry", false);
				}
			});
		});

		if(m.sceneRestarting === false) {
			m.diceHand = new DiceHand(m);
			m.cup = new Cup(m);
			m.ui = new UI(m);
		}

		m.playfield = this.add.image(m.config.width / 2, pushDownAmount, 'playfieldNoFrame').setInteractive();

		m.playfield.setScale(m.config.width / m.playfield.width, m.config.width / m.playfield.width);
		m.playfield.setOrigin(0.5, 0);

		// var watermark = this.add.image(m.config.width / 2, m.config.height * 0.47, 'watermark');
		// let sc = m.playfield.scaleX * 0.94;
		// watermark.setScale(sc, sc);

		m.playfieldFrame = this.add.image(m.config.width / 2, pushDownAmount, 'playfieldFrame');

		m.playfieldFrame.setScale(m.config.width / m.playfieldFrame.width, m.config.width / m.playfieldFrame.width);
		m.playfieldFrame.setOrigin(0.5, 0);
		m.playfieldFrame.setDepth(2);

		m.playfieldLowPosition = m.playfieldFrame.y;
		let pfHeight = m.playfieldFrame.height * m.playfieldFrame.scaleY;
		let pfBottom = m.playfieldFrame.y + pfHeight;
		let upAmount = (pfBottom - m.config.height);
		if(upAmount > 350)
			upAmount = 350;
		m.playfieldHighPosition = m.playfieldFrame.y - upAmount;

		m.cup.create();
		if(m.sceneRestarting === false) {
			m.diceHand.create();
		} else {
			m.diceHand.reCreate();
		}

		m.diceHand.clearDiceOffScreen();

		// m.music = this.sound.add('backgroundMusic', {
		// 	mute: false,
		// 	volume: 0.25,
		// 	rate: 1,
		// 	detune: 0,
		// 	seek: 0,
		// 	loop: true,
		// 	delay: 0
		// });

		m.scene.anims.create({
			key: 'handSpin',
			frames: m.scene.anims.generateFrameNumbers('goalPanel', {
				start: 10,
				end: 14
			}),
			frameRate: 30,
			repeat: 4
		});

		m.scene.anims.create({
			key: 'flair',
			frames: m.scene.anims.generateFrameNumbers('flair', {
				start: 2,
				end: 9
			}),
			frameRate: 10,
			repeat: -1
		});

		m.scene.anims.create({
			key: 'selected',
			frames: m.scene.anims.generateFrameNumbers('flair', {
				start: 10,
				end: 25
			}),
			frameRate: 20,
			repeat: -1
		});
		m.scene.anims.create({
			key: 'flairYellowDot',
			frames: m.scene.anims.generateFrameNumbers('flairYellowDot', {
				start: 2,
				end: 9
			}),
			frameRate: 10,
			repeat: -1
		});

		m.scene.anims.create({
			key: 'selectedYellowDot',
			frames: m.scene.anims.generateFrameNumbers('flairYellowDot', {
				start: 10,
				end: 10
			}),
			frameRate: 20,
			repeat: -1
		});
		m.scene.anims.create({
			key: 'portraitBlur',
			frames: m.scene.anims.generateFrameNumbers('portrait_blur', {
				start: 0,
				end: 9
			}),
			frameRate: 30,
			repeat: 3 //6 //10
		});

		m.scene.anims.create({
			key: 'prePortraitBlur',
			frames: m.scene.anims.generateFrameNumbers('portrait_blur', {
				start: 0,
				end: 9
			}),
			frameRate: 30,
			repeat: -1 //10
		});

		this.anims.create({
			key: 'handPoint',
			frames: this.anims.generateFrameNumbers('hand', {
				start: 0,
				end: 1
			}),
			frameRate: 2,
			repeat: 0
		});


		//Poof
		var frameNames = this.anims.generateFrameNames('poofNoCloud', {
			start: 1,
			end: 20,
			prefix: 'poof_no_cloud_',
			suffix: '.png'
		});
		this.anims.create({
			key: 'poof',
			frames: frameNames,
			frameRate: 30,
			repeat: 0,
			hideOnComplete: true
		});


		//Cup Swirl
		frameNames = this.anims.generateFrameNames('swirl', {
			start: 1,
			end: 29,
			zeroPad: 4,
			prefix: 'swirl',
			suffix: '.png'
		});
		this.anims.create({
			key: 'cupSwirl',
			frames: frameNames,
			frameRate: 30,
			repeat: -1
		});

		//Floating Stars
		frameNames = this.anims.generateFrameNames('floatingStars', {
			start: 2,
			end: 29,
			zeroPad: 4,
			prefix: 'floatingStars',
			suffix: '.png'
		});
		this.anims.create({
			key: 'floatingStars',
			frames: frameNames,
			frameRate: 30,
			repeat: -1
		});

		store.phaserReady = true;

		// integration.postAnalyticsEvent(`gameLaunch`, store.skin);

		// this.cameras.main.setRoundPixels(true);

		m.startMusic();
		m.onCreateComplete();

		store.setSpinner(false);

		m.sceneRestarting = true;

	}.bind(this,store.phaserInstanceIndex);

}
